import React, {useCallback} from 'react';

const Pagination = ({ current, total, onChangePage}) => {

  const renderPaging = useCallback(() => {
    var elem = [];
    for(let i=0;i<total;i++)
    {
      elem.push(
        <a href="#" className={i == current ? "active" : ""} key={"pagination_"+i} onClick={(e) => {
          e.preventDefault();
          onChangePage(i);
        }}>{i+1}</a>
      )
    }

    return elem;
  },[current, total])

  return (
    <div className="pagination">
      {renderPaging()}
    </div>
  );
}

export default Pagination